import { actionTypes } from '../actions/actionTypes'

const initialState = {
  consentContent: null,
  loading: null,
  error: null
}

export default (state = initialState, action) => {
  switch(action.type){
  case actionTypes.CONSENT_CONTENT.SET_CONSENT_CONTENT:
    return { ...state, ...action.value }
  case actionTypes.CONSENT_CONTENT.SET_LOADING:
    return { ...state, loading: action.value }
  case actionTypes.CONSENT_CONTENT.SET_ERROR:
    return { ...state, error: action.value }
  default:
    return state
  }
}